import createCustomAxios from '../utils/axios';
const http = createCustomAxios();
const httpDataBase = createCustomAxios(
	'https://data.drcnet.com.cn/statistical'
);
const httpExpert = createCustomAxios('https://expert.drcnet.com.cn/expert');
// 导航接口
export function getNav(params) {
	return http({
		method: 'get',
		url: '/WebChannelCommonController/getMenuList',
		params,
	});
}
// 文章接口1
export function getDocList(params) {
	return http({
		method: 'get',
		url: '/indexController/getIndexDocs',
		params,
	});
}
// 文章接口2
export function getDocsByUids(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getDocsByUids',
		params,
	});
}
//热点专题
export function getIndexHotTopicDocs(params) {
	return http({
		method: 'get',
		url: '/DocCommonController/getIndexHotTopicDocs',
		params,
	});
}
//国研网数据统计库
export function tables2(params) {
	return httpDataBase({
		method: 'get',
		url: '/homepage/tables2',
		params,
	});
}
//专家库-关系
export function relation(params) {
	return httpExpert({
		method: 'get',
		url: '/api/aggregation/expert/relation',
		params,
	});
}
//专家库-词云
export function nameList(params) {
	return httpExpert({
		method: 'get',
		url: '/api/aggregation/keyword/nameList',
		params,
	});
}
// 热点专题-新
export function homePageHotTopic() {
	return http({
		method: 'get',
		url: '/CommonController/common/getHomePageHotTopic',
	});
}

